import React from "react";
import styles from "./FilterSidebar.module.scss";

const FilterSidebar = ({ tabs, activeCategory, setActiveCategory }) => {
    return (
        <div className={styles.sidebar}>
            <ul>
                {tabs?.map((category) => (
                    <li
                        key={category.key}
                        className={activeCategory === category.key ? styles.active : ""}
                        onClick={() => setActiveCategory(category.key)}
                    >
                        {category.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FilterSidebar;